/* EASTEAM — PDP Before/After slider (Drop 05 2.0, front + back since 2026-10-16, iOS touch fix + re-attach/fit fix 2026-10-17)
   Appends the fit slides (and their thumbnails) to the END of the PDP gallery:
   a draggable before/after of the same model in the nude base plate vs the piece.
     · front only  → one slide, thumb badge "FIT" (exactly as Drop 05 shipped)
     · front + back → two slides, "FIT · FRONT" then "FIT · BACK", each draggable,
                      thumb badges "FIT · F" / "FIT · B"
   Additive by design — sections/easteam-pdp.liquid is untouched.
   Config comes from snippets/ea-ba-slider.liquid as window.EA_BA
   ({ before, after, back: { before, after } | null, ... }).
   MIRRORS the PDP gallery markup: .gallery > .slides > .slide  and  .thumbs > .thumb[data-ea-thumb].
   If that markup changes in easteam-pdp.liquid, change it here too. */
(function () {
  'use strict';
  var CFG = window.EA_BA;
  if (!CFG || !CFG.before || !CFG.after) return;

  var PAIRS = [{ key: 'front', view: 'Front', before: CFG.before, after: CFG.after }];
  if (CFG.back && CFG.back.before && CFG.back.after) {
    PAIRS.push({ key: 'back', view: 'Back', before: CFG.back.before, after: CFG.back.after });
  }
  var MULTI = PAIRS.length > 1;

  /* 2026-10-17 — small / short screen rules, shipped with the JS so they always arrive
     together with the fit-to-slide sizing below. */
  (function () {
    if (document.getElementById('ea-ba-fit-css')) return;
    var st = document.createElement('style');
    st.id = 'ea-ba-fit-css';
    st.textContent = [
      '.ea-pdp .slide.ea-ba-slide{min-width:0;overflow:hidden}',
      '.ea-ba{flex:0 0 auto;max-height:100%}',
      '.ea-ba .ea-ba-hint{white-space:nowrap}',
      '.ea-ba.ea-ba--sm .ea-ba-tag{top:10px;font-size:8px;letter-spacing:.14em}',
      '.ea-ba.ea-ba--sm .ea-ba-tag-b{left:8px}',
      '.ea-ba.ea-ba--sm .ea-ba-tag-a{right:8px}',
      '.ea-ba.ea-ba--sm .ea-ba-view{top:30px;font-size:8px;letter-spacing:.16em;padding:3px 7px}',
      '.ea-ba.ea-ba--sm .ea-ba-hint{bottom:10px;font-size:8px;letter-spacing:.12em;padding:4px 8px}',
      '.ea-ba.ea-ba--xs .ea-ba-tag{font-size:7px;letter-spacing:.1em;top:8px}',
      '.ea-ba.ea-ba--xs .ea-ba-tag-b{left:6px}',
      '.ea-ba.ea-ba--xs .ea-ba-tag-a{right:6px}',
      '.ea-ba.ea-ba--xs .ea-ba-view{top:24px;font-size:7px;letter-spacing:.1em;padding:2px 5px}',
      '.ea-ba.ea-ba--xs .ea-ba-hint{display:none}',
      '.ea-ba.ea-ba--xs .ea-ba-knob{width:20px;height:34px;border-radius:10px}'
    ].join('\n');
    (document.head || document.documentElement).appendChild(st);
  })();

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function buildSlider(pair) {
    var box = el('div', 'ea-ba');
    box.setAttribute('tabindex', '0');
    box.setAttribute('role', 'slider');
    box.setAttribute('aria-label', 'Before and after' + (MULTI ? ', ' + pair.view.toLowerCase() + ' view' : '') + ': ' + (CFG.title || 'this piece'));
    box.setAttribute('aria-valuemin', '0');
    box.setAttribute('aria-valuemax', '100');
    box.setAttribute('aria-valuenow', '50');

    var after = el('img');
    after.src = pair.after;
    after.alt = (CFG.title || '') + ' worn' + (MULTI ? ', ' + pair.view.toLowerCase() : '');
    after.loading = 'eager'; after.decoding = 'async';
    after.draggable = false;

    var beforeWrap = el('div', 'ea-ba-before');
    var before = el('img');
    before.src = pair.before;
    before.alt = 'Without the piece';
    before.loading = 'eager'; before.decoding = 'async';
    before.draggable = false;
    beforeWrap.appendChild(before);

    var line = el('div', 'ea-ba-line');
    line.appendChild(el('div', 'ea-ba-knob',
      '<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true" focusable="false">' +
      '<path d="M9 5v14M15 5v14" stroke="#0A0807" stroke-width="2" stroke-linecap="round" fill="none"/></svg>'));

    box.appendChild(after);
    box.appendChild(beforeWrap);
    box.appendChild(el('span', 'ea-ba-tag ea-ba-tag-b', CFG.labelBefore || 'Before'));
    box.appendChild(el('span', 'ea-ba-tag ea-ba-tag-a', CFG.labelAfter || 'After'));
    if (MULTI) box.appendChild(el('span', 'ea-ba-view', 'Fit &middot; ' + pair.view));
    box.appendChild(line);
    box.appendChild(el('div', 'ea-ba-hint', CFG.hint || 'Drag to reveal'));

    var dragging = false;

    function set(p) {
      p = Math.max(0, Math.min(100, p));
      beforeWrap.style.width = p + '%';
      line.style.left = p + '%';
      before.style.width = (p > 0.5 ? (10000 / p) : 20000) + '%';
      box.setAttribute('aria-valuenow', String(Math.round(p)));
    }
    function fromEvent(e) {
      var r = box.getBoundingClientRect();
      if (!r.width) return;
      set(((e.clientX - r.left) / r.width) * 100);
    }
    box.addEventListener('pointerdown', function (e) {
      /* touch is handled by the touch listeners below (horizontal drags only), so a finger
         that is just scrolling the page past the slider doesn't make the wipe jump */
      if (e.pointerType === 'touch') return;
      dragging = true;
      box.classList.add('is-touched');
      try { box.setPointerCapture(e.pointerId); } catch (err) {}
      fromEvent(e);
      e.preventDefault();
      e.stopPropagation();
    });
    box.addEventListener('pointermove', function (e) { if (dragging) { fromEvent(e); e.preventDefault(); } });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (t) {
      box.addEventListener(t, function () { dragging = false; });
    });
    /* 2026-10-17 — iPhone / iOS Safari. Inside the gallery's horizontal scroll-snap
       carousel, WebKit can hand a sideways swipe to the carousel before any pointermove
       reaches the slider (touch-action:pan-y is not reliably honoured there), so on iPhone
       the wipe never moved and the swipe just changed photo. Handle touch directly:
       a mostly-horizontal drag is claimed by the slider (preventDefault on a non-passive
       touchmove), a mostly-vertical one is left alone so the page still scrolls. */
    var tX = 0, tY = 0, tMode = null;
    box.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      tX = e.touches[0].clientX; tY = e.touches[0].clientY; tMode = null;
      box.classList.add('is-touched');
      e.stopPropagation();
    }, { passive: true });
    box.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1) return;
      var t = e.touches[0];
      if (tMode === null) {
        var dx = Math.abs(t.clientX - tX), dy = Math.abs(t.clientY - tY);
        if (dx < 4 && dy < 4) return;
        tMode = dx >= dy ? 'h' : 'v';
      }
      if (tMode === 'h') {
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        fromEvent(t);
      }
    }, { passive: false });
    ['touchend', 'touchcancel'].forEach(function (t) {
      box.addEventListener(t, function (e) {
        if (tMode === 'h') e.stopPropagation();
        tMode = null;
      }, { passive: true });
    });

    /* the gallery slide is .zoomable on normal slides; this one is not, but stop any
       stray click from bubbling into the theme's lightbox handlers anyway */
    box.addEventListener('click', function (e) { e.stopPropagation(); });
    box.addEventListener('keydown', function (e) {
      var cur = parseFloat(box.getAttribute('aria-valuenow')) || 50;
      if (e.key === 'ArrowLeft') { set(cur - 4); box.classList.add('is-touched'); e.preventDefault(); }
      if (e.key === 'ArrowRight') { set(cur + 4); box.classList.add('is-touched'); e.preventDefault(); }
    });
    /* 2026-10-17 — size the 2:3 box to FIT the slide in both directions (like the
       photos' object-fit:contain). The old CSS (height:100% + aspect-ratio) made the box
       wider than the screen on tall narrow phones, so the slide spilled past the edge. */
    function fit() {
      var s = box.parentElement;
      if (!s) return;
      var sw = s.clientWidth, sh = s.clientHeight;
      if (!sw || !sh) return;
      var ratio = (after.naturalWidth && after.naturalHeight) ? after.naturalWidth / after.naturalHeight : 2 / 3;
      var w = Math.min(sw, sh * ratio), h = w / ratio;
      box.style.width = Math.floor(w) + 'px';
      box.style.height = Math.floor(h) + 'px';
      box.classList.toggle('ea-ba--sm', w < 300);
      box.classList.toggle('ea-ba--xs', w < 200);
    }
    box._eaFit = fit;
    after.addEventListener('load', fit);
    set(50);
    return box;
  }

  function attach(gallery) {
    if (gallery.querySelector('.ea-ba')) return true;
    var slides = gallery.querySelector('.slides');
    if (!slides || !slides.children.length) return false;

    var model = slides.children[slides.children.length - 1];
    var thumbs = gallery.parentElement && gallery.parentElement.querySelector('.thumbs');
    if (!thumbs) thumbs = document.querySelector('.thumbs');
    var hasThumbs = !!(thumbs && thumbs.children.length);
    /* 2026-10-17: mobile shows dots (.gdots) under the gallery instead of thumbs. The PDP
       builds them before these slides exist, so it drew 5 dots for 7 slides and the
       gallery looked finished before the fit slides. Add one dot per fit slide. */
    var dots = (gallery.parentElement && gallery.parentElement.querySelector('[data-ea-gdots]')) ||
               document.querySelector('.ea-pdp [data-ea-gdots]');

    var made = []; // [{ slide, thumb, dot }]

    PAIRS.forEach(function (pair) {
      var slide = el('div', 'slide ea-ba-slide ea-ba-slide-' + pair.key);
      /* copy inline sizing the theme may have put on a slide, but never .zoomable */
      if (model.getAttribute('style')) slide.setAttribute('style', model.getAttribute('style'));
      var box = buildSlider(pair);
      slide.appendChild(box);
      slides.appendChild(slide);
      box._eaFit();
      if (window.ResizeObserver) { try { new ResizeObserver(box._eaFit).observe(slide); } catch (err) {} }

      var myThumb = null;
      if (hasThumbs) {
        var idx = slides.children.length - 1;
        myThumb = el('button', 'thumb ea-ba-thumb');
        myThumb.type = 'button';
        myThumb.dataset.eaThumb = String(idx);
        myThumb.setAttribute('aria-label', 'Before and after' + (MULTI ? ', ' + pair.view.toLowerCase() : ''));
        var timg = el('img');
        timg.src = pair.after;
        timg.alt = '';
        timg.loading = 'lazy';
        myThumb.appendChild(timg);
        var badge = MULTI ? (CFG.thumbBadge || 'FIT') + ' · ' + pair.view.charAt(0) : (CFG.thumbBadge || 'FIT');
        myThumb.appendChild(el('span', 'ea-ba-thumb-badge', badge));
        thumbs.appendChild(myThumb);
        myThumb.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          goToSlide(slide);
        });
      }
      var myDot = null;
      if (dots) {
        myDot = el('span', 'gdot ea-ba-gdot');
        myDot.setAttribute('aria-hidden', 'true');
        dots.appendChild(myDot);
        myDot.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goToSlide(slide); });
      }
      made.push({ slide: slide, thumb: myThumb, dot: myDot });
    });

    /* scroll-snap plus smooth behaviour is unreliable on this carousel, so the
       smooth attempt is followed by a hard assignment if it did not land */
    function goToSlide(slide) {
      var target = slide.offsetLeft - slides.offsetLeft;
      try {
        slides.scrollTo({ left: target, behavior: 'smooth' });
      } catch (err) {
        slides.scrollLeft = target;
      }
      setTimeout(function () {
        if (Math.abs(slides.scrollLeft - target) > 4) slides.scrollLeft = target;
        syncActive();
      }, 450);
    }

    /* keep the active-thumb state in sync: the section's own observer was built
       before these slides existed, so it never sees them */
    function syncActive() {
      if (!hasThumbs && !dots) return;
      var r = slides.getBoundingClientRect();
      var mid = r.left + r.width / 2;
      var hit = null;
      made.forEach(function (m) {
        var s = m.slide.getBoundingClientRect();
        if (s.left <= mid && s.right >= mid) hit = m;
      });
      if (hit) {
        if (hit.thumb) {
          Array.prototype.forEach.call(thumbs.children, function (t) { t.classList.remove('on'); });
          hit.thumb.classList.add('on');
        }
        if (hit.dot) {
          Array.prototype.forEach.call(dots.children, function (d) { d.classList.remove('on'); });
          hit.dot.classList.add('on');
        }
      } else {
        made.forEach(function (m) {
          if (m.thumb) m.thumb.classList.remove('on');
          if (m.dot) m.dot.classList.remove('on');
        });
      }
    }
    var tick;
    slides.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(syncActive, 80);
    }, { passive: true });
    window.addEventListener('resize', function () { clearTimeout(tick); tick = setTimeout(syncActive, 120); });
    syncActive();
    return true;
  }

  function run() {
    var done = false;
    document.querySelectorAll('.ea-pdp .gallery').forEach(function (g) { if (attach(g)) done = true; });
    return done;
  }

  /* 2026-10-17 — the PDP REBUILDS its gallery (slides + dots) on every window resize.
     On iPhone a resize fires whenever the address bar shrinks/grows while scrolling,
     and on rotation, so the fit slides "sometimes" disappeared. Watch the PDP and
     re-attach whenever a rebuilt gallery comes back without them. */
  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; run(); });
  }
  function watch() {
    if (!window.MutationObserver) return;
    var root = document.querySelector('.ea-pdp') || document.body;
    try { new MutationObserver(queue).observe(root, { childList: true, subtree: true }); } catch (err) {}
    if (root !== document.body) {
      /* if the whole .ea-pdp section is swapped, watch the new one */
      try {
        new MutationObserver(function () {
          var r2 = document.querySelector('.ea-pdp');
          if (r2 && r2 !== root) { root = r2; new MutationObserver(queue).observe(r2, { childList: true, subtree: true }); queue(); }
        }).observe(document.body, { childList: true, subtree: true });
      } catch (err) {}
    }
  }
  function boot() {
    watch();
    window.addEventListener('resize', function () { setTimeout(run, 300); });
    window.addEventListener('orientationchange', function () { setTimeout(run, 500); });
    window.addEventListener('pageshow', function () { run(); });
    if (run()) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (run() || tries > 120) clearInterval(iv);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
